import { FilterOption } from "./types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findValueByName = (arr: FilterOption[] | undefined, targetName: string): any => {
  if (!arr) return null;
  const result = arr.find((item) => item.name === targetName);
  return result ? result.value : null;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const findDefaultValueByName = (arr: FilterOption[] | undefined, targetName: string): any => {
  if (!arr) return null;
  const result = arr.find((item) => item.name === targetName);
  return result && 'defaultValue' in result ? result.defaultValue : "";
}; 